"use strict";

require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _useResponsiveImageContext = _interopRequireDefault(require("./useResponsiveImageContext"));
var _default = _useResponsiveImageContext["default"];
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VSZXNwb25zaXZlSW1hZ2VDb250ZXh0Il0sInNvdXJjZXMiOlsiLi4vLi4vc3JjL3VzZVJlc3BvbnNpdmVJbWFnZUNvbnRleHQvaW5kZXguanMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHVzZVJlc3BvbnNpdmVJbWFnZUNvbnRleHQgZnJvbSAnLi91c2VSZXNwb25zaXZlSW1hZ2VDb250ZXh0JztcblxuZXhwb3J0IGRlZmF1bHQgdXNlUmVzcG9uc2l2ZUltYWdlQ29udGV4dDtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7QUFBQTtBQUFvRSxlQUVyREEscUNBQXlCO0FBQUEifQ==